import { assignInlineVars } from '@vanilla-extract/dynamic'
import { clsx } from 'clsx'
import { useTranslation } from 'react-i18next'
import { hidden } from '../../../theme.css'
import { EQuestName } from '../../../types/enums'
import { trpc } from '../../../utils'
import { Button } from '../../atoms'
import type { QuestType } from '../../pages/Rewards/types'
import {
  bottomSection,
  buttonStyle,
  descriptionStyle,
  noRewardButtonWrapper,
  progress,
  progressBarContainerStyle,
  progressBarStyle,
  questButtonSection,
  questProgress,
  rewardStyle,
  taskHeaderStyle,
  taskItemStyle,
} from './index.css'

export const QuestItem = (props: {
  quest: QuestType
  noRewardButton?: React.ReactNode
  onUpdate: (quest: QuestType) => void
}) => {
  const { mutateAsync: requestReward, isPending } =
    trpc.quest.requestReward.useMutation()
  const { t } = useTranslation()

  const progressPercent = (100 / (props.quest.goal ?? 1)) * props.quest.progress
  const questTitleParams: Partial<
    Record<EQuestName, Record<string, string | number>>
  > = {
    [EQuestName.DAILY_CLAIM_REWARD]: {
      day: props.quest.progress || 1,
    },
  }
  const questDescriptionParams: Partial<
    Record<EQuestName, Record<string, string | number>>
  > = {
    [EQuestName.INVITE_A_FRIEND]: {
      invatedCount: props.quest.progress || 0,
    },
  }

  const onClickCollect = async () => {
    const response = await requestReward({
      systemName: props.quest.systemName,
    })
    if (response.success) {
      const questProgress = {
        ...props.quest,
      }
      if (typeof response.questProgress?.progress === 'number') {
        questProgress.progress = response.questProgress.progress
      }
      props.onUpdate({
        ...questProgress,
        status: 'REWARDED',
        canReward: false,
      })
    }
  }

  return (
    <div className={taskItemStyle}>
      <div className={taskHeaderStyle}>
        <span>
          {t(
            `rewards.quest.${props.quest.systemName}.title`,
            questTitleParams[props.quest.systemName],
          )}
        </span>
        <span className={rewardStyle}>{props.quest.reward}</span>
      </div>
      <div className={progressBarContainerStyle}>
        <div
          className={progressBarStyle}
          style={assignInlineVars({
            [progress]: `${progressPercent}`,
          })}
        />
      </div>
      <div className={bottomSection}>
        <div className={descriptionStyle}>
          {t(
            `rewards.quest.${props.quest.systemName}.description`,
            questDescriptionParams[props.quest.systemName],
          )}
        </div>
        <span className={questButtonSection}>
          <span
            className={clsx(
              questProgress,
              props.quest.canReward ||
                (!props.quest.canReward && props.noRewardButton)
                ? hidden
                : null,
            )}
          >
            {props.quest.goal
              ? `${props.quest.progress} / ${props.quest.goal}`
              : props.quest.progress || 0}
          </span>
          <span
            className={clsx(
              noRewardButtonWrapper,
              props.quest.status !== 'ACTIVE' ? hidden : undefined,
            )}
          >
            {props.noRewardButton}
          </span>
          <Button
            className={buttonStyle}
            variant='primary'
            disabled={isPending}
            hidden={!props.quest.canReward}
            analytic={{
              name: 'collect',
              params: {
                quest: props.quest.systemName.toLowerCase(),
              },
            }}
            onClick={() => {
              void onClickCollect()
            }}
          >
            {t('rewards.button.collect')}
          </Button>
        </span>
      </div>
    </div>
  )
}
